var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Vue, Component, Watch, Prop } from "vue-facing-decorator";
import { SystemsClient, SystemStatesModel, ComponentStatusEnum, SortDirection, SortDescription } from "@/app/api/battery-portal-api";
import { Notifier } from "@//common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import Sorter from "@/common/utils/sorter";
import RouteNames from "@/app/router/routes";
import QueryStringHelper from "@/app/utils/querystring-helper";
import 'leaflet.markercluster';
const systemsClient = new SystemsClient(window.apiUrl);
const queryStringHelper = new QueryStringHelper();
let SystemDashboardVue = class SystemDashboardVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.activeTab = 0;
        this.companyFilter = null;
        this.siteFilter = null;
        this.filteredSystemsUnknown = null;
        this.sorter = new Sorter(new SortDescription({
            fieldName: "SystemName",
            direction: SortDirection.Ascending
        }));
        this.data = new SystemStatesModel({
            totalNumberOfSystems: 0,
            totalNumberOfGeoMappedSystems: 0,
            totalNumberOfCriticalSystems: 0,
            totalNumberOfWarningSystems: 0,
            totalNumberOfHealthySystems: 0,
            totalNumberOfUnknownSystems: 0,
            systems: new Array()
        });
    }
    created() {
        this.getSystemStates();
    }
    ;
    mounted() {
    }
    ;
    // get
    getSystemStates() {
        if (this.working)
            return;
        this.working = true;
        systemsClient
            .getSystemStates()
            .then(response => {
            this.data = response;
            this.$emit("onDataLoaded", response);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    getCssClass(system) {
        var _a;
        if (!system.statusId)
            return `unknown`;
        return ((_a = system.statusName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
    }
    ;
    getAddressLine(system) {
        let details = [system.siteName, system.streetAddress3].filter(Boolean);
        return `${details.map(item => {
            return TextHelper.stripHtml(item);
        }).join(", ")}`;
    }
    ;
    getAlarmAckCount(system, filter) {
        let count = filter == "critical" ? system.numberOfCriticalAlarmsAck : system.numberOfWarningAlarmsAck;
        if (!count)
            return ``;
        return count > 100 ? `100+` : count.toString();
    }
    ;
    getAlarmNackCount(system, filter) {
        let count = filter == "critical" ? system.numberOfCriticalAlarmsNack : system.numberOfWarningAlarmsNack;
        if (!count)
            return ``;
        return count > 100 ? `100+` : count.toString();
    }
    ;
    goToSystemView(system) {
        if (system.hasRealTime) {
            // Navigate to Real-Time page with systemId as query parameter
            this.$router.push({
                name: RouteNames.RealTime,
                query: { systemId: system.systemId.toString() }
            });
        }
        else {
            // Navigate to Snapshot page
            // Create a unique key and send as parameter to reload the last snapshot case the page is cached.
            var uniqueKey = Math.floor(new Date().getTime() / 1000).toString();
            this.$router.push({
                name: RouteNames.SnapshotForSystem,
                params: { systemId: system.systemId.toString(), uniqueKey: uniqueKey }
            });
        }
    }
    ;
    onSortChanged() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        let sort = this.sorter.currentSort;
        switch (sort.fieldName) {
            case "SystemName":
                (_a = this.data.systems) === null || _a === void 0 ? void 0 : _a.sort((a, b) => {
                    var _a, _b;
                    let systemA = `${(_a = a.systemName) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`;
                    let systemB = `${(_b = b.systemName) === null || _b === void 0 ? void 0 : _b.toLowerCase()}`;
                    if (systemA < systemB)
                        return -1;
                    if (systemA > systemB)
                        return 1;
                    return 0;
                });
                if (sort.direction == SortDirection.Descending)
                    (_c = (_b = this.data) === null || _b === void 0 ? void 0 : _b.systems) === null || _c === void 0 ? void 0 : _c.reverse();
                break;
            case "SiteName":
                (_d = this.data.systems) === null || _d === void 0 ? void 0 : _d.sort((a, b) => {
                    var _a, _b;
                    let systemA = `${(_a = a.siteName) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`;
                    let systemB = `${(_b = b.siteName) === null || _b === void 0 ? void 0 : _b.toLowerCase()}`;
                    if (systemA < systemB)
                        return -1;
                    if (systemA > systemB)
                        return 1;
                    return 0;
                });
                if (sort.direction == SortDirection.Descending)
                    (_f = (_e = this.data) === null || _e === void 0 ? void 0 : _e.systems) === null || _f === void 0 ? void 0 : _f.reverse();
                break;
            case "NumberOfAlarms":
                (_g = this.data.systems) === null || _g === void 0 ? void 0 : _g.sort((a, b) => a.numberOfCriticalAlarmsAck + a.numberOfWarningAlarmsAck + a.numberOfCriticalAlarmsNack + a.numberOfWarningAlarmsNack -
                    (b.numberOfCriticalAlarmsAck + b.numberOfWarningAlarmsAck + b.numberOfCriticalAlarmsNack + b.numberOfWarningAlarmsNack));
                if (sort.direction == SortDirection.Descending)
                    (_j = (_h = this.data) === null || _h === void 0 ? void 0 : _h.systems) === null || _j === void 0 ? void 0 : _j.reverse();
                break;
        }
        ;
    }
    ;
    hasAlarms(system) {
        return system.numberOfCriticalAlarmsAck + system.numberOfWarningAlarmsAck + system.numberOfCriticalAlarmsNack + system.numberOfWarningAlarmsNack > 0;
    }
    get getFilteredSystemsHealthy() {
        return this.visibleSystems.filter(x => x.statusId == ComponentStatusEnum.Healthy).length;
    }
    get getFilteredSystemsCritical() {
        return this.visibleSystems.filter(x => x.statusId == ComponentStatusEnum.Critical).length;
    }
    get getFilteredSystemsWarning() {
        return this.visibleSystems.filter(x => x.statusId == ComponentStatusEnum.Warning).length;
    }
    get getFilteredAckCriticalAlarms() {
        var count = 0;
        this.visibleSystems.forEach(system => {
            count += system.numberOfCriticalAlarmsAck;
        });
        return count;
    }
    get getFilteredNackCriticalAlarms() {
        var count = 0;
        this.visibleSystems.forEach(system => {
            count += system.numberOfCriticalAlarmsNack;
        });
        return count;
    }
    get getFilteredAckWarningAlarms() {
        var count = 0;
        this.visibleSystems.forEach(system => {
            count += system.numberOfWarningAlarmsAck;
        });
        return count;
    }
    get getFilteredNackWarningAlarms() {
        var count = 0;
        this.visibleSystems.forEach(system => {
            count += system.numberOfWarningAlarmsNack;
        });
        return count;
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Array !== "undefined" && Array) === "function" ? _a : Object)
], SystemDashboardVue.prototype, "systemStates", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], SystemDashboardVue.prototype, "companyFilter", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], SystemDashboardVue.prototype, "siteFilter", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof Array !== "undefined" && Array) === "function" ? _b : Object)
], SystemDashboardVue.prototype, "visibleSystems", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], SystemDashboardVue.prototype, "filteredSystemsUnknown", void 0);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemDashboardVue.prototype, "onSortChanged", null);
SystemDashboardVue = __decorate([
    Component({
        name: "SystemDashboardVue",
        components: {},
        emits: ["onDataLoaded"]
    })
], SystemDashboardVue);
export default SystemDashboardVue;
